import { Box, Flex, Heading, Text } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';
import { ListCardDetailsItem } from '../ListCard/ListCardDetailsItem';

interface GndDetailsProps {
  employeeId: string;
  band: string;
  positionTitle: string;
  description: string;
  category: string;
}

export function GndDetails({
  employeeId,
  band,
  positionTitle,
  description,
  category,
}: GndDetailsProps) {
  const { t } = useTranslate();

  const renderGndSpecificFields = () => {
    const fields = [];
    
    if (category === 'You are Giving') {
      fields.push(
        <ListCardDetailsItem
          key="typeOfRecipient"
          label="Type of Recipient"
          value="N/A"
        />
      );
      fields.push(
        <ListCardDetailsItem
          key="typeOfGift"
          label="Type of Gift"
          value="N/A"
        />
      );
      fields.push(
        <ListCardDetailsItem
          key="totalAmountInUsd"
          label="Total Amount in USD"
          value="N/A"
        />
      );
    }
    
    if (category === 'You are Receiving') {
      fields.push(
        <ListCardDetailsItem
          key="typeOfProvider"
          label="Type of Provider"
          value="N/A"
        />
      );
      fields.push(
        <ListCardDetailsItem
          key="typeOfGift"
          label="Type of Gift"
          value="N/A"
        />
      );
      fields.push(
        <ListCardDetailsItem
          key="totalAmountInUsd"
          label="Total Amount in USD"
          value="N/A"
        />
      );
    }
    
    if (category === 'Office Internal Usage') {
      fields.push(
        <ListCardDetailsItem
          key="dateOfEvent"
          label="Date of the event"
          value="N/A"
        />
      );
      fields.push(
        <ListCardDetailsItem
          key="totalAmountInUsd"
          label="Total Amount in USD"
          value="N/A"
        />
      );
    }
    
    return fields;
  };

  const gndSpecificFields = renderGndSpecificFields();

  return (
    <Box
      css={{
        marginTop: '$4',
        padding: '$2',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        border: '1px solid #EEEFF2',
        mx: '$24',
      }}
    >
      <Flex justify="between">
        <Flex direction="column" css={{ m: '$4', width: '50%' }}>
          <Heading css={{ fontSize: '$sm', mb: '$4' }}>
            {t('my_tickets.list.details.employee_details')}
          </Heading>
          <Box
            css={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '$5',
            }}
          >
            <ListCardDetailsItem
              label={t('my_tickets.list.details.employee_id')}
              value={employeeId}
            />
            <ListCardDetailsItem
              label={t('my_tickets.list.details.employee_band')}
              value={band}
            />
            <ListCardDetailsItem
              label={t('my_tickets.list.details.position_title')}
              value={positionTitle}
            />
            {gndSpecificFields}
          </Box>
        </Flex>
        
        <Flex direction="column" css={{ m: '$4', width: '50%' }}>
          <Heading css={{ fontSize: '$sm', mb: '$4' }}>
            {t('common.description')}
          </Heading>
          <Text>{description}</Text>
        </Flex>
      </Flex>
    </Box>
  );
}
